export default {"src":"/_next/static/media/benefit-light.77b12bd6.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};